import { render, staticRenderFns } from "./TuzelSahis.vue?vue&type=template&id=24c24154&"
import script from "./TuzelSahis.vue?vue&type=script&lang=js&"
export * from "./TuzelSahis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports